import { render, staticRenderFns } from "./UnmatchedStudentsDialogMobile.vue?vue&type=template&id=60394660&scoped=true"
import script from "./UnmatchedStudentsDialogMobile.vue?vue&type=script&lang=js"
export * from "./UnmatchedStudentsDialogMobile.vue?vue&type=script&lang=js"
import style0 from "./UnmatchedStudentsDialogMobile.vue?vue&type=style&index=0&id=60394660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60394660",
  null
  
)

export default component.exports